import Http from "../Http";
import { INSPECTION_URL } from "../Helper";


export function sendVerfyEmail(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + "send_verification_email" , values)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
        });
    }